import { render } from "./featured-article.presentational.vue?vue&type=template&id=7c0bd15c"
import script from "./featured-article.presentational.vue?vue&type=script&lang=js"
export * from "./featured-article.presentational.vue?vue&type=script&lang=js"

import "./featured-article.presentational.vue?vue&type=style&index=0&id=7c0bd15c&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__